// extracted by mini-css-extract-plugin
export default {"googleButton":"GoogleLoginButton_googleButton__vN-f7","googleIcon":"GoogleLoginButton_googleIcon__BjBeI"};